export function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 overflow-hidden"
    >
      {/* Bokeh light effects */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 right-20 w-32 h-32 bg-rose-500/20 rounded-full blur-3xl"></div>
        <div className="absolute top-40 right-60 w-24 h-24 bg-emerald-500/15 rounded-full blur-2xl"></div>
        <div className="absolute top-60 right-32 w-20 h-20 bg-amber-500/20 rounded-full blur-2xl"></div>
        <div className="absolute bottom-40 left-20 w-28 h-28 bg-cyan-500/15 rounded-full blur-3xl"></div>
        <div className="absolute top-32 left-40 w-16 h-16 bg-rose-400/10 rounded-full blur-xl"></div>
        <div className="absolute bottom-60 right-40 w-20 h-20 bg-amber-400/15 rounded-full blur-2xl"></div>
      </div>

      <div className="relative z-20 max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center pt-24 sm:pt-28 lg:pt-20 pb-12 sm:pb-16">
        {/* Text Content */}
        <div className="text-left space-y-4 sm:space-y-6 order-2 lg:order-1">
          <div className="space-y-3 sm:space-y-5">
            <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight whitespace-nowrap">
              Dr. Arash Yousefi, MD
            </h1>
            <p className="text-emerald-400 font-medium text-base sm:text-lg md:text-xl tracking-wide">
              Trusted Expert in NeuroTrauma Care
            </p>
            <p className="text-lg sm:text-xl md:text-2xl text-white/90 leading-relaxed">
              Double Board-Certified in Neurology & Interventional Pain Management
            </p>
            <p className="text-sm sm:text-base md:text-lg text-white/75 leading-relaxed max-w-xl">
              Expert in Traumatic Brain Injury, Complex Pain Management, and Medical-Legal Evaluations
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-4 sm:pt-6">
            <a
              href="tel:818-221-8000"
              className="inline-flex items-center justify-center gap-2 sm:gap-3 bg-emerald-500 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-sm sm:text-base md:text-lg font-semibold hover:bg-emerald-400 transition-all duration-300 shadow-lg shadow-emerald-500/30 hover:shadow-emerald-400/40 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-lg sm:text-xl"></i>
              Call Now: (818) 221-8000
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-sm sm:text-base md:text-lg font-semibold border border-white/20 hover:bg-white/20 hover:border-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-line text-lg sm:text-xl"></i>
              Book Appointment
            </a>
          </div>
        </div>

        {/* Photo */}
        <div className="relative flex justify-center lg:justify-end order-1 lg:order-2">
          <div className="relative">
            {/* Glow effect behind image */}
            <div className="absolute -inset-4 sm:-inset-6 bg-gradient-to-br from-emerald-500/25 via-cyan-500/15 to-rose-500/20 rounded-[2rem] blur-3xl"></div>

            {/* Main image container */}
            <div className="relative w-64 h-[350px] sm:w-80 sm:h-[440px] md:w-96 md:h-[500px] lg:w-[400px] lg:h-[520px] rounded-2xl overflow-hidden shadow-2xl shadow-black/50 border border-white/10">
              <img
                src="https://static.readdy.ai/image/23ade0805c842f9b7ab135282ab65771/f6feab119113084a4eb8b07ec3ddc8d7.jpeg"
                alt="Dr. Arash Yousefi, MD - Neurologist and Pain Management Specialist"
                className="w-full h-full object-cover object-[center_20%]"
              />
              {/* Subtle overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}